import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"border":"solid #2c2c2c","border-width":"1px 0px"} }


export default /*@__PURE__*/_defineComponent({
  __name: 'ModulesTab',
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function onTabChange(val: string) {
  emit('update:modelValue', val);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": onTabChange,
      color: "white"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: tab.name,
            value: tab.name,
            disabled: tab.disabled,
            style: {"text-transform":"none","letter-spacing":"0"}
          }, {
            default: _withCtx(() => [
              (tab.icon)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.icon), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(tab.label), 1)
            ]),
            _: 2
          }, 1032, ["value", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})